import {attachFroalaEditor} from "../../../../plugins/froala-editor";

export default function popupScripts() {
    attachFroalaEditor();

    const $button = $(".popupTypeButton");
    const $modals = $(".popupTypeModal");
    const $select = $('#popup\\.type_id');

    $button.click(function () {
        const typeLabel = getSelectedPopupTypeLabel();
        $("#popupType" + typeLabel + "Modal").modal('show');
    });

    $modals.on("hide.bs.modal", function () {
        setSelectedItemsCount();
    });

    $select.on('change', function() {
        setButtonVisibility();
        setSelectedItemsCount();
    });

    function getSelectedPopupTypeLabel() {
        const $selectedTypeId = $select.find(':selected');
        const popupType = $(document).find('input[value=' + $selectedTypeId.val() + ']')
        const typeLabel = popupType.data('typeLabel');

        return typeLabel[0].toUpperCase() + typeLabel.slice(1);
    }

    function setButtonVisibility() {
        $button.toggleClass('hide', 'All' === getSelectedPopupTypeLabel());
    }

    setButtonVisibility();

    function setSelectedItemsCount() {
        const typeLabel = getSelectedPopupTypeLabel();
        const selectedItemsCount = $("#popupType" + typeLabel + "Modal :checked").length;
        const $buttonCountSpan = $button.find('span.count').text(selectedItemsCount);
        $buttonCountSpan.text(selectedItemsCount);
    }

    setSelectedItemsCount();
}
